// Live mirror of getContactById.service.js's awaitingCommentReply/hasPendingCommentReply
// (Meta Private Reply). Those flags are only recomputed server-side on a REST fetch, so the
// socket handlers patch them from the customer message that just arrived; a refresh always
// re-syncs from the server.
export const getCommentReplyPatch = (chat, isOwnedByContact, isInternal = false) => {
  if (!chat || isInternal || !isOwnedByContact) return {};
  if (chat.status !== "received" && chat.status !== "delivered") return {};
  if (chat.sendername || chat.senderid) return {};

  if (chat.type === "post_comment") {
    // The server only tracks a pending reply for Meta's real comment id, not the synthetic
    // ig_comment_/fb_comment_ fallback ids.
    const hasRealCommentId = !!chat.id && !/^(ig|fb)_comment_/.test(String(chat.id));
    return hasRealCommentId ? { awaitingCommentReply: false, hasPendingCommentReply: true } : {};
  }
  // Any other real inbound message opens the normal messaging window.
  return { awaitingCommentReply: false };
};
